import type { Ranking } from "../../api/rankings.service";

export const COLUMN_CONFIGS = [
  {
    header: "Company Name",
    accessor: "companyName" as keyof Ranking,
  },
  {
    header: "Practice Area",
    accessor: "wpPracticeAreaName" as keyof Ranking,
  },
  {
    header: "Country",
    accessor: "wpCountryName" as keyof Ranking,
  },
  {
    header: "Tier",
    accessor: "rankingTier" as keyof Ranking,
  },
  {
    header: "Ranking Type",
    accessor: "rankingType" as keyof Ranking,
  },
  {
    header: "Table Name",
    accessor: "rankingTableName" as keyof Ranking,
  },
  {
    header: "Site",
    accessor: "site" as keyof Ranking,
  },
  {
    header: "Global",
    accessor: "isGlobal" as keyof Ranking,
  },
];

export const MODAL_FIELD_CONFIGS: Array<{ key: keyof Ranking; label: string }> = [
  { key: "id", label: "ID" },
  { key: "wpRankingId", label: "WP Ranking ID" },
  { key: "companyId", label: "Company ID" },
  { key: "companyName", label: "Company Name" },
  { key: "companySlug", label: "Company Slug" },
  { key: "wpPracticeAreaId", label: "WP Practice Area ID" },
  { key: "wpPracticeAreaName", label: "Practice Area" },
  { key: "wpCountrySlug", label: "Country Slug" },
  { key: "wpCountryName", label: "Country" },
  { key: "rankingTier", label: "Tier" },
  { key: "rankingType", label: "Ranking Type" },
  { key: "rankingTableName", label: "Table Name" },
  { key: "site", label: "Site" },
  { key: "hasAccoladeCssLtq", label: "Accolade: CSS LTQ" },
  { key: "hasAccoladeCssVbe", label: "Accolade: CSS VBE" },
  { key: "hasAccoladeCssSik", label: "Accolade: CSS SIK" },
  { key: "hasAccoladeNps", label: "Accolade: NPS" },
  { key: "isGlobal", label: "Global" },
  { key: "hasUpdatedContent", label: "Updated Content" },
];
